import { Component, OnInit } from '@angular/core';
import { CoreService } from '../../services/coreService';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-terms-conditions',
    templateUrl: './terms-conditions.component.html',
    styleUrls: ['./terms-conditions.component.scss'],
    standalone: true,
    imports: []
})
export class TermsConditionsComponent implements OnInit {
  data:any;
  selectedLanguage="en";
  private sub: any;

  constructor(private coreService: CoreService,private route: ActivatedRoute,) {

    this.sub = this.route.params.subscribe(params => {      
      this.selectedLanguage=params["id"];
    //   this.coreService.GetTerms()
    //  .toPromise()
    //  .then((response : any) => {
    //    var html: any;
    //    html= response.data;
    //    if(this.selectedLanguage=="en")
    //    this.data = html.privacy_policy_en_content
    //    else
    //    this.data= html.privacy_policy_ar_content
    //  })  
    });
   }

  ngOnInit() {
  }

}
